import { makeStyles } from "@tiny/components";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
  },
  text: {
    display: "none",
    [theme.breakpoints.up("lg")]: {
      display: "inline",
    },
  },
  action: {
    minWidth: "auto",
    width: "auto",
    height: 24,
    margin: "0 6px",
    padding: 0,
    color: theme.palette.grey[700],
    fontSize: 14,
    "&:hover": {
      color: theme.palette.grey[900],
      background: "transparent",
    },
    "& svg": {
      width: 24,
      height: 24,
    },
    [theme.breakpoints.up("md")]: {
      margin: "0 4px",
    },
  },
}));
